import { autoinject } from 'aurelia-framework';
import { AvailableInstrumentClient, QueryInstrumentsResponseItem as LookupQueryInstrumentsResponseItem } from '@dynamik/common/clients/instrument-clients';
import { InstrumentsClient, UnconvertedInstrumentsViewModel } from '@dynamik/common/clients/transaction-clients';

declare module '@dynamik/common/clients/transaction-clients' {
  export interface UnconvertedInstrumentsViewModel {
    lookupQueryInstrumentsResponseItem?: LookupQueryInstrumentsResponseItem;
  }
}

@autoinject
export class UnconvertedInstrumentsService {
  constructor(private instrumentsClient: InstrumentsClient, private availableInstrumentClient: AvailableInstrumentClient) { }

  promise: Promise<UnconvertedInstrumentsViewModel[]>;
  currentCompanyId: number;

  async getCached(companyId: number, resetCache = false) {
    if (!this.promise || this.currentCompanyId !== companyId || resetCache) {
      this.promise = this.get(companyId);
      this.currentCompanyId = companyId;
    }
    return this.promise;
  }

  private async get(companyId: number) {
    const [inboxUnconverted, existingUnnoted] = await Promise.all([
      this.instrumentsClient.unconverted(companyId),
      this.instrumentsClient.existingUnnoted(companyId)
    ]);
    const noted = await this.availableInstrumentClient.searchByIsins(companyId, existingUnnoted.filter(x => x.availableInstrument).map(x => x.availableInstrument.isin).filter(x => !!x));
    const lookupUnconverted = noted.map(x => {
      const unnoted = existingUnnoted.find(y => y.availableInstrument?.isin === x.isin);
      const p = new UnconvertedInstrumentsViewModel({
        availableInstrument: unnoted.availableInstrument,
        instrument: unnoted
      });
      p.lookupQueryInstrumentsResponseItem = x;
      return p;
    });

    return lookupUnconverted.concat(inboxUnconverted.filter(x => !lookupUnconverted.some(y => y.availableInstrument.isin === x.availableInstrument.isin)))
      .sort((a, b) => a.availableInstrument.name.localeCompare(b.availableInstrument.name));
  }
}
